import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Color Palette */
    --primary: #FFFFFF;
    --secondary: #000000;
    --accent-1: #71797E;
    --accent-2: #990000;
    --accent-3: #E0E0E0;
    
    /* Spacing System */
    --spacing-xs: 8px;
    --spacing-sm: 16px;
    --spacing-md: 24px;
    --spacing-lg: 32px;
    --spacing-xl: 48px;
    --spacing-xxl: 64px;
    --spacing-xxxl: 96px;

    /* Container */
    --container-width: 1200px;
  }

  @font-face {
    font-family: 'DIN';
    src: url('https://fonts.cdnfonts.com/css/din-condensed') format('woff2');
    font-weight: 400;
    font-style: normal;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    font-family: 'Inter', 'Helvetica', 'Arial', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    background-color: var(--primary);
    color: var(--secondary);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Barlow Condensed', 'Helvetica Neue', 'Arial', sans-serif;
    font-weight: 700;
    margin-bottom: var(--spacing-md);
    text-transform: uppercase;
  }

  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 2.5rem;
  }

  h3 {
    font-size: 2rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: var(--spacing-md);
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    color: var(--secondary);
    text-decoration: none;
    transition: all 0.3s ease;
    
    &:hover {
      color: var(--accent-3);
    }
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Inter', 'Helvetica', 'Arial', sans-serif;
  }

  ul {
    list-style: none;
  }

  .container {
    width: 100%;
    max-width: var(--container-width);
    margin: 0 auto;
    padding: 0 var(--spacing-md);
  }

  /* Responsive Breakpoints */
  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }
    
    h2 {
      font-size: 2rem;
    }
    
    h3 {
      font-size: 1.75rem;
    }
    
    h4 {
      font-size: 1.25rem;
    }
  }
`;

export default GlobalStyles; 